import { DropdownMenuContent } from '#app/components/ui/dropdown-menu'

interface FilterDropdownContentProps {
	children: React.ReactNode
}

const FilterDropdownContent = ({ children }: FilterDropdownContentProps) => {
	return (
		<DropdownMenuContent
			align="end"
			className="relative z-50 mt-2 max-h-60 overflow-y-auto rounded-lg border-[1px] border-beige-90 bg-white shadow-lg scrollbar-hide data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2"
		>
			{children}
		</DropdownMenuContent>
	)
}

export default FilterDropdownContent
